import { render, staticRenderFns } from "./LandingLogistics.vue?vue&type=template&id=02d167ac&scoped=true"
import script from "./LandingLogistics.vue?vue&type=script&lang=js"
export * from "./LandingLogistics.vue?vue&type=script&lang=js"
import style0 from "./LandingLogistics.vue?vue&type=style&index=0&id=02d167ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d167ac",
  null
  
)

export default component.exports